<template>
	<div>
		<div class="new-container" v-if="flag == '2'">
			<div class="login-main">
				<div class="top-logo">
					<img :src="loginT" @click="gotoHome"/>
				</div>
				<div class="login-carousel">
					<div class="carousel-box">
						<el-carousel trigger="click" :interval="4000" height="320px" v-if="banner.length>0">
							<el-carousel-item v-for="item in banner" :key="item.id">
								<div class="carousel-item-box">
									<img :src="item.img" />
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="page-login-box">
						<Login></Login>
					</div>
				</div>
				<div class="login-bto-main">
					<div class="login-bto-left">
						<div class="bto-left-top">
              <div class="bar-b">
                <div class="bar-title">
                  <div class="icon-box">
                    <img src="../assets/login/tender_icon.svg" />
                    <span>采购公告</span>
                  </div>
                  <div class="show-more" @click="showMoreList('purchase')">查看更多</div>
                </div>
                <div class="notice-box" v-if="cgxyNotice && cgxyNotice.length>0">
                  <div class="notice-list" v-for="item in cgxyNotice" :key="item.id" @click="shouCGNotice(item)">
                    <div class="notice-title">{{item.title}}</div>
                    <div class="notice-time">{{item.date}}</div>
                  </div>
                </div>
                <div v-else class="no-data-img" style="margin-top:100px">
                  <img src="../assets/login/no_source.svg"/>
                </div>
              </div>
							<div class="bar-a">
								<div class="bar-title">
									<div class="icon-box">
										<img src="../assets/login/bid_icon.svg" />
										<span>中标公告</span>
									</div>
									<div class="show-more" @click="showMoreList('tender')">查看更多</div>
								</div>
								<div class="notice-box" v-if="zbggNotice && zbggNotice.length>0">
									<div class="notice-list" v-for="item in zbggNotice" :key="item.id" @click="shouZbNotice(item)">
										<div class="notice-title">关于“{{item.orderTitle}}”的中标公告</div>
										<div class="notice-time">{{item.date}}</div>
									</div>
								</div>
								<div v-else class="no-data-img" style="margin-top:100px">
									<img src="../assets/login/no_notice.svg"/>
								</div>
							</div>

						</div>
						<div class="bto-left-bottom">
							<div class="bar-c">
								<div class="bar-title">
									<div class="icon-box">
										<img src="../assets/login/intro_icon.svg" />
										<span>企业介绍</span>
									</div>
								</div>
                <div class="notice-title" style="margin-left: 14px; margin-right: 14px; font-size: 14px">
                  <div>&nbsp;&nbsp;&nbsp;&nbsp;分宜县数字产业投资发展有限公司于2022年8月16日注册成立，2023年9月划拨至天工集团，由县投资控股集团全额出资设立，性质为国有有限责任公司，经县政府授权，对县本级政府数据的开发利用进行运营管理。
                    </div>
                </div>
							</div>
							<div class="bar-d">
								<div class="bar-title">
									<div class="icon-box">
										<img src="../assets/login/link_icon.svg" />
										<span>企业链接</span>
									</div>
								</div>
                <div class="notice-title" style="margin-left: 18px;font-size: 14px"><div>官方网址：<a target="_blank" href="http://www.ifenyi.com">www.ifenyi.com</a></div></div>
                <div class="notice-title" style="margin-left: 18px;font-size: 14px"><div>招采网址：<a href="http://zc.ifenyi.com">zc.ifenyi.com</a></div></div>
							</div>
							<div class="bar-d">
								<div class="bar-title">
									<div class="icon-box">
										<img src="../assets/login/contact_icon.svg" />
										<span>联系方式</span>
									</div>
								</div>
                <div class="notice-title" style="margin-left: 18px;font-size: 14px"><div>官方联系电话：0790-5788577</div></div>
                <div class="notice-title" style="margin-left: 18px;font-size: 14px"><div>商务合作：0790-5788577</div></div>
                <div class="notice-title" style="margin-left: 18px;font-size: 14px"><div>人员招聘：0790-5788577</div></div>
							</div>
						</div>
					</div>
					<div class="login-bto-right">
						<div class="bar-e">
							<div class="bar-title">
								<div class="icon-box">
									<img src="../assets/login/server_icon.svg" />
									<span>服务中心</span>
								</div>
							</div>
              <div class="notice-box">
                <div class="notice-title" style="margin-left: 14px;font-size: 14px"><div>商务服务电话：13320002999</div></div>
                <div class="notice-title" style="margin-left: 14px;font-size: 14px"><div>技术服务电话：19142163617</div></div>
                <div class="notice-title" style="margin-left: 14px;font-size: 14px"><div>服务中心地址：江西省新余市分宜县万年北路31号104-105。</div></div>
              </div>
						</div>
						<div class="bar-f">
							<div class="bar-title">
								<div class="icon-box">
									<img src="../assets/login/tender_icon.svg" />
									<span>企业公告</span>
								</div>
								<div class="show-more" @click="showMoreList('company')">查看更多</div>
							</div>
							<div class="notice-box">
								<div class="notice-list" v-for="item in qzNotice" :key="item.id" @click="shouNotice(item)">
									<div class="notice-title">{{item.title}}</div>
									<div class="notice-time">{{item.date}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
<!--			<div class="foot-bar">-->
<!--        <div class="footer">-->
<!--          <div class="box">-->
<!--            <div class="left_box">-->
<!--              <div class="enter item_list">-->
<!--                <p class="title">关于我们</p>-->
<!--                <a href="http://www.shuziys.com/index.html" target="_blank">公司简介</a>-->
<!--              </div>-->
<!--              <div class="enter item_list">-->
<!--                <p class="title">快捷入口</p>-->
<!--&lt;!&ndash;                <a :href="GetMenuUrl().purchase">采购信息</a>&ndash;&gt;-->
<!--&lt;!&ndash;                <a :href="GetMenuUrl().result">采购结果公示</a>&ndash;&gt;-->
<!--&lt;!&ndash;                <a :href="GetMenuUrl().help">帮助中心</a>&ndash;&gt;-->
<!--&lt;!&ndash;                <a :href="GetMenuUrl().notice">系统公告</a>&ndash;&gt;-->
<!--                <a>采购信息</a>-->
<!--                <a>采购结果公示</a>-->
<!--                <a>帮助中心</a>-->
<!--                <a>系统公告</a>-->
<!--              </div>-->
<!--              <div class="enter item_list">-->
<!--                <p class="title">友情链接</p>-->
<!--                <a href="http://www.xinyu.gov.cn/" target='_blank'>新余市人民政府</a>-->
<!--                <a href="http://www.yushui.gov.cn/" target='_blank'>渝水区人民政府</a>-->
<!--                <a href="http://www.shuziys.com/index.html" target='_blank'>渝水数投官网</a>-->
<!--              </div>-->
<!--              <div class="contact item_list">-->
<!--                <p class="title">联系我们</p>-->
<!--                <p>地址：新余市渝水区大一路22号渝水区工业和数字投资有限公司</p>-->
<!--&lt;!&ndash;                <p>联系电话：6258957</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p>邮箱：www.ysqgst@163.com</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p>工作时间：周一至周五 9:00-17:00</p>&ndash;&gt;-->
<!--              </div>-->
<!--              <div class="right_ewm item_list">-->
<!--&lt;!&ndash;                <img src="images/gzh.jpg" />&ndash;&gt;-->
<!--                <p>数字渝水</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="footer_footer">-->
<!--              <span>Copyright © 2023 新余市渝水区数字经济投资发展有限公司 版权所有</span>-->
<!--              <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2021004115号-1</a>-->
<!--            </div>-->
<!--            <div class="support">-->
<!--              <span>技术支持：</span>-->
<!--              <a href="http://www.shuziys.com/index.html" target='_blank'>新余市渝水区数字经济投资发展有限公司</a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
		</div>
		<div class="container" v-if="flag == '1'">
			<div class="container-body">
				<div class="sy-header">
					<el-row class="sy-header-title">
						<el-col :span="18">
							<div class="sy-title">
								<!-- <img width="25" height="25" /> --> 分宜数投招采平台
							</div>
						</el-col>
						<el-col :span="6" style="text-align: right;">
							<span style="font-size:13px;">访问量 {{ fangwenliang }}</span>
						</el-col>
					</el-row>
				</div>
				<div class="nav">
					<ul id="nav">
						<li>
							<a href="/b2b/main/preIndex.html" class="nav_a">首页</a>
						</li>
						<li>
							<a href="/b2b/main/listVendorNotice.html?noticeType=2" class="">采购公告</a>
						</li>
						<li>
							<a href="/b2b/main/preSupplierManagement.html" class="">中标公告</a>
						</li>
						<li>
							<a href="/b2b/main/preSupplierManagement.html" class="">企业公告</a>
						</li>
					</ul>
				</div>
				<div class="sy-body">
					<el-row :gutter="10">
						<el-col :span="18">
							<el-carousel class="sy-car" height="100%" :interval="8000">
								<el-carousel-item v-for="(item,index) in carouselList " :key="index">
									<img :src="item" style="width: 100%; height: 100%;" />
								</el-carousel-item>
							</el-carousel>
						</el-col>
						<el-col :span="6">
							<div class="sy-login">
								<Login></Login>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="sy-footer">
					<div style="width: 75%;padding-right: 10px;" class="card-bottom-border">
						<el-card class="box-card" shadow="never" style="height: 176px;">
							<div slot="header">
								<div class="car-head">
									<div class="car-head-title"><i
											style="font-size: 18px; color: #1989FA;padding-right: 5px;"
											class="el-icon-s-operation"></i>通知公告</div>
									<div class="car-head-more" @click="toMoreGg(1)">
										更多<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</div>
							<div class="car-body">
								<gongGao isDoor="1" ggflMh="通知公告"></gongGao>
							</div>
						</el-card>
					</div>
					<div style="width: 25%;padding-left: 10px;">
						<el-card class="box-card" shadow="never" style="background-color: #f6f6f6;height: 176px;">
							<div slot="header">
								<div class="car-head-bg">
									<div class="car-head-title"><i style="font-size: 20px; color: #fff;padding-right: 5px;"
											class="el-icon-s-operation"></i>系统通知</div>
									<div class="car-head-more" @click="toMoreGg(1)">
										更多
									</div>
								</div>
							</div>
							<div class="car-body">
								<el-timeline>
									<el-timeline-item type="info" hide-timestamp>
										2021-05-06 系统更新
									</el-timeline-item>
									<el-timeline-item type="info" hide-timestamp>
										2021-05-06 系统更新
									</el-timeline-item>
								</el-timeline>
							</div>
						</el-card>
					</div>
				</div>
				<div style="mg-t15">
					<footer class="footer">
						Copyright © 2024 技术支持： All Rights Reserved.
					</footer>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import loginT from '../assets/login_logo1.png'
	import c1 from '../assets/login/c1.png'
	import c2 from '../assets/login/c2.png'
	import c3 from '../assets/login/c3.png'
	import Login from '@/components/Login/login.vue'
	import gongGao from '@/components/gongGao/index.vue';
	import { getNoticeList,zhongbiaoAnnouncementList,xunyuanAnnouncementList} from '../api/notice'
	export default {
		components: {
			Login,
			gongGao
		},
		data() {
			return {
				flag:2,
				loginT,
				banner:[
					{id:1, img:c1,},
					{id:2, img:c2,},
					{id:3, img:c3,},
				],
				carouselList: ['https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'],
				fangwenliang: 100, // 历史访问量

				qzNotice:[],	// 企业公告
				cgxyNotice:[],	// 采购公告
				zbggNotice:[],	// 中标公告
			};
		},
		created() {
			this.getNoticelist()
			this.getXunyuanAnnouncementList()
			this.zhongbiaoAnnouncementListFun()
		},
		methods: {
      gw(){
        this.$success('官方网站正在抓紧建设中，敬请期待。')
      },
			toMoreGg: function(index) {
				let param = {
					isDoor: '1',
				};
				if (index == 1) {
					param.ggflMh = '通知公告';
				} else if (index == 2) {
					param.ggflMh = '机构招聘';
				} else if (index == 3) {
					param.ggflMh = '监督求职';
				}
				let routeUrl = this.$router.resolve({
					path: "/moreGg",
					query: param
				});
				window.open(routeUrl.href, '_blank');

			},
			// 获取公告
			async getNoticelist(){
				 let _this = this;
				const {
					data: res
				} = await getNoticeList({
					page: 1, //当前页码
					limit: 10, //当前每页显示的数量
					objMap: {
						announcementType:'',
						publicHomePage:'是'
					}
				})
				if (res.code == 0) {
					_this.qzNotice = res.data||[];
					_this.qzNotice.forEach((item)=>{
						item['date'] = '';
						if(item.createTime){
							item['date'] = item.createTime.split(' ')[0];
						}
					})
				}
			},
			// 获取采购公告列表
			async getXunyuanAnnouncementList(){

				let _this = this;
				const {
					data: res
				} = await xunyuanAnnouncementList({
					page: 1, //当前页码
					limit: 8, //当前每页显示的数量
					objMap:{
						status:'0'
					}
				})
				if (res.code == 0) {
					_this.cgxyNotice = res.data||[];
					_this.cgxyNotice.forEach((item)=>{
						item['date'] = '';
						if(item.createTime){
							item['date'] = item.createTime.split(' ')[0];
						}
					})
				}
			},
			// 获取中标公告立碑
			zhongbiaoAnnouncementListFun(){
				let _this = this;
				zhongbiaoAnnouncementList({
					page: 1, //当前页码
					limit: 8, //当前每页显示的数量
				}).then(({data:res})=>{
					if(res.code == 0){
						_this.zbggNotice = res.data || [];
						_this.zbggNotice.forEach((item)=>{
							item['date'] = '';
							if(item.createTime){
								item['date'] = item.createTime.split(' ')[0];
							}
						})
					}
				})
			},
			// 查看更多
			showMoreList(type){
				this.$router.push({path: `/morenotice/${type}`});
			},
			// shouCGNotice(){
      // 	this.$warn('请登录后查看！')
      //   //都能查看
      //
      // },
      shouZbNotice(item){
        window.open(`/zbggNoticeInfo/${item.id}`)
      },
      shouCGNotice(item){
        window.open(`/cgggNoticeInfo/${item.id}`)
      },
			shouNotice(item){
				window.open(`/noticeinfo/${item.id}`)
			},
      gotoHome(){
        this.$router.push({path: `/login`});
      },
		}
	};
</script>

<style scoped="scoped" lang="scss">
	.new-container{
		width: 100%;
		min-height: 100vh;
		background: #F6F9FD;
		.notice-box{
			width: calc(100% - 20px);
			padding: 0 10px;
			overflow-y: auto;
		}
		.notice-list{
			width: calc(100% - 10px);
			padding: 0 5px;
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			display: flex;
			justify-content: space-between;
			cursor: pointer;
			&:hover{
				/* background:rgba(41,190,206,.3); */
				background:#ecf5ff;
			}
			.notice-title{
				flex: 1;
				margin-right: 10px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				word-break: break-all;
				color: #333;
			}
			.notice-time{
				font-size: 12px;
				color: #999;
			}
		}
		.login-main{
			width: 1200px;
			margin: 0 auto;
			.top-logo{
				width: 100%;
				height: 40px;
				padding: 20px 0;
				text-align: left;
				img{
					height: 40px;
				}
			}
		}
		.login-carousel{
			width: 100%;
			height: 320px;
			display: flex;
			justify-content: space-between;
			margin-bottom: 20px;
			.carousel-box{
				width: 880px;
				background: #fff;
				height: 320px;
				.el-carousel__button{
					height: 6px;
					border-radius: 3px;
					background: rgba(0,0,0,.6);
					width: 24px;
				}
				.el-carousel__indicator.is-active button{
					background: #fff;
					opacity: 1;
				}
				.el-carousel__arrow{
					background-color: rgba(31, 45, 61, 0.4);
				}
				.carousel-item-box{
					width: 100%;
					height: 600px;
					background: #eee;
					text-align: center;
					line-height: 600px;
					position: relative;
					img{
						width: 880px;
						height: 320px;
					}
				}
			}
			.page-login-box{
				width: 300px;
				margin-left: 20px;
				background: #fff;
			}
		}
		.login-bto-main{
			width: 100%;
			display: flex;
			justify-content: space-between;
			padding-bottom: 40px;
			.login-bto-left{
				width: 880px;
				.bto-left-top{
					width: 100%;
					height: 300px;
					display: flex;
					justify-content: space-between;
					margin-bottom: 20px;
					.bar-a{
						width: 430px;
						height: 300px;
						background: #fff;
						.notice-box{
							max-height: 460px;
						}
					}
					.bar-b{
						width: 430px;
						height: 300px;
						background: #fff;
						.notice-box{
							max-height: 460px;
						}
					}
				}
				.bto-left-bottom{
					width: 100%;
					height: 200px;
					display: flex;
					justify-content: space-between;
					.bar-c{
						width: 320px;
						height: 200px;
						background: #fff;
					}
					.bar-d{
						width: 260px;
						height: 200px;
						background: #fff;
					}
				}
			}
			.login-bto-right{
				width: 300px;
				.bar-e{
					width: 100%;
					height: 160px;
					background: #fff;
					margin-bottom: 20px;
				}
				.bar-f{
					width: 100%;
					height: 340px;
					background: #fff;
					.notice-box{
						max-height: 500px;
					}

				}
			}
		}
		.foot-bar{
			width: 100%;
			height: 330px;
			// position: fixed;
			// left: 0;
			// bottom: 0;
			background: #31353E;
			font-size: 12px;
			color: #ACAEB1;
			line-height: 60px;
			text-align: center;

      .footer{
        background-color: #2E3033;
        margin-top: 40px;

        .box{
          width: 1200px;
          margin: 0 auto;
          padding: 35px 0 20px;

          .left_box{
            border-bottom: 1px solid #43464A;
            padding-bottom: 30px;
            margin-top: 300px;

            .item_list {
              display: inline-block;
              vertical-align: top;
              width: 200px;

              .title{
                color: #FFFFFF;
                font-size: 16px;
                margin-bottom: 25px;
              }

              a{
                display: block;
                color: #FFFFFF;
                font-size: 12px;
                height: 12px;
                line-height: 12px;
                margin-bottom: 10px;
              }
            }

            .contact{
              width: 340px;
            }
          }
        }
        .footer_footer{
          margin-top: 10px;
          span{
            color: #999999;
            font-size: 14px;
          }
          a{
            color: #999999;
            font-size: 14px;
          }
        }
      }
		}
		.bar-title{
			width: calc(100% - 40px);
			padding: 0 20px;
			height: 40px;
			display: flex;
			justify-content: space-between;
			line-height: 40px;
			.icon-box{
				display: flex;
				align-items: center;
				font-size: 16px;
				img{
					height: 14px;
					margin-right: 10px;
				}
			}
			.show-more{
				font-size: 12px;
				color: #29BECE;
				cursor: pointer;
			}
		}
		.no-data-img{
			width: calc(100% - 40px);
			padding: 20px;
			text-align: center;
			img{
				width: 170px;
			}
		}
	}


	.container {
		height: auto;
		background-color: #f3f4f6;
		padding-bottom: 10px;

	}

	.container-body {
		width: 1150px;
		margin: 0 auto;
		background-color: #FFFFFF;
		padding: 0px 10px;
		border: 1px solid #eaeaea;
	}

	.sy-title {
		font-size: 22px;
		font-weight: 600;
		display: flex;
		flex-direction: row;
		align-items: center;

	}

	.sy-header {
		height: 10vh;
		color: #FFFFFF;
		// background: url(../imgs/logoback.png) no-repeat center center;
		margin-bottom: 10px;
	}

	.sy-header-title {
		display: flex;
		height: 100%;
		align-items: center;
	}

	.sy-car {
		height: 40vh;
		background-color: #EAEDF1;
		margin-top: 5px;
		margin: 0 auto;
	}

	.sy-login {
		height: 40vh;
		background: #F5F7FA;
	}

	.nav {
		background: #d2edfe;
		border-bottom: #52a6d5 solid 4px;
		height: 40px;
		margin: auto;
		margin-bottom: 10px;
	}

	.nav ul li {
		float: left;
	}

	li {
		line-height: 20px;
	}

	li {
		list-style: none;
	}

	.nav li .nav_a {
		background: #52a6d6;
		color: #fff;
	}

	.nav li a:hover {
		background: #52a6d6;
		color: #fff;
	}

	.nav a,
	.nav a:active {
		line-height: 40px;
		height: 40px;
		padding: 0 20px;
		color: #666;
		display: block;
		font-weight: bold;
		font-size: 12px;
	}

	.sy-body {
		margin-bottom: 10px;
	}

	.footer {
		color: #fff;
		display: flex;

		justify-content: center;
		align-items: center;
		height: 8vh;
		margin: 0px auto;
		background-color: #3a8ee6;
	}

	.sy-footer {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.sy-footer /deep/.el-card__header {
		padding-left: 0px;
		padding-right: 0px;
		padding-top: 0px;
		padding-bottom: 5px;
	}

	.card-bottom-border /deep/.el-card__header {
		border-bottom: 2px #e9e9e9 solid;
	}

	.car-body {
		font-size: 14px;
		padding: 5px;
	}

	.car-head {
		width: 100%;
		font-size: 14px;
		color: #333333;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.el-card {
		border-radius: 0px;
	}

	.car-head-bg {
		width: 100%;
		font-size: 14px;
		color: #FFFFFF;
		background-color: #52a6d5;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		height: 32px;
		font-weight: bold;


	}

	.car-head-title {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
	}

	.el-card {
		border: none;
	}

	.car-head-more {
		font-weight: 400;
		font-size: 13px;
		padding: 3px 0px;
		width: 40px;
		text-indent: 0px;
		text-align: center;
		cursor: pointer;
	}

	.car-head-more:hover {
		color: #3a8ee6;
	}
</style>
